// 取引情報 編集
const ModalBuildingEditorTransaction = {
  namespaced: true,

  state: {
    // 部屋編集 建物側の取引情報を編集する モーダル
    modal: false,
    item: {
      ea_charge_id: null,
      ea_id: null,
      name_eacompany: '',
      transaction: null,
      um_eachargeperson_name: '',
      um_eachargeperson_tel: '',
    },
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getItem: state => {
      return state.item
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setItem(state, item) {
      state.item = item
    },
  },
  actions: {},
}

export default ModalBuildingEditorTransaction
